import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "10 9 15 4 20 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 20h7a4 4 0 0 0 4-4V4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CornerRightUp";
const CornerRightUp = memo(themed(Icon));
export {
  CornerRightUp
};
//# sourceMappingURL=corner-right-up.js.map
